const Spinner = ({ dimension }) => (
  <div id="loading" style={{ width: dimension, height: dimension }} />
);

export default Spinner;
